const React = require('react')
const PropTypes = require('prop-types')
const withStyles = require('withStyles').default
const styles = require('./nav.less')

const AppLinks = require('./app_links')
const AnonymousLinks = require('./anonymous_links')
const ViewerLinks = require('./viewer_links')
const { AnonymousComponent } = require('component/viewer/anonymous')
const { LoggedInComponent } = require('component/viewer/logged_in')

const log = require('log').create('nav') // eslint-disable-line

function Nav(props) {
    return (
        <nav className="topnav">
            <AppLinks {...props} />
            <AnonymousComponent>
                <AnonymousLinks {...props} />
            </AnonymousComponent>
            <LoggedInComponent>
                <ViewerLinks {...props} />
            </LoggedInComponent>
        </nav>
    )
}

Nav.propTypes = {
    link_logo: PropTypes.bool,
    render_signup: PropTypes.bool,
    render_login: PropTypes.bool,
    signup_button_props: PropTypes.object,
}

Nav.defaultProps = {
    link_logo: true,
    render_signup: true,
    render_login: true,
    signup_button_props: {},
}

module.exports = withStyles(styles)(Nav)
